// extracted by mini-css-extract-plugin
export default {"footerLeft":"Footer_footerLeft__xyFiB","footerRight":"Footer_footerRight__Ro0J5"};